<template>
  <div id="meetingParticipants">
    <v-row>
      <v-col md="12" class="pt-2">
        <v-combobox
          v-model="selectedAttendees"
          :items="suggestionListItems"
          :filter="filter"
          :search-input.sync="attendeeSearch"
          ref="combobox"
          class="searchComboBox"
          id="searchComboBox"
          :label="label"
          item-color="#f4f4f4"
          dense
          chips
          multiple
          filled
          hide-details
          @input="attendeeSearch = null"
          item-text="email"
          item-value="id"
          return-object
          :eager="true"
          :disabled="disabled"
        >
          <template v-slot:selection="data">
            <v-chip
              small
              :key="JSON.stringify(data.item)"
              v-bind="data.attrs"
              :input-value="data.selected"
              :disabled="data.disabled || data.item.disabled"
              @click:close="!data.disabled && data.parent.selectItem(data.item)"
              color="secondary darken-3"
              class="ma-1 pl-2"
              close
              @click="data.select"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-avatar
                    v-if="data.item.email"
                    left
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img
                      v-if="data.item.profilePhoto"
                      contain
                      :src="data.item.profilePhoto"
                    ></v-img>
                    <v-img
                      v-else
                      contain
                      src="@/assets/images/NoPhotoIcon.png"
                    ></v-img>
                  </v-avatar>
                  <span v-if="data.item.firstName" v-bind="attrs" v-on="on">
                    {{ data.item.firstName + " " + data.item.lastName }}
                  </span>
                  <span v-else v-bind="attrs" v-on="on">
                    {{ data.item.email }}</span
                  >
                </template>
                <span>
                  <ul
                    v-if="data.item.emailList"
                    style="list-style: none; padding: 0px"
                  >
                    <li>
                      {{ data.item.email }}
                    </li>
                    <li
                      v-for="email in data.item.emailList"
                      :key="`select-chip-email-${email}`"
                    >
                      {{ email }}
                    </li>
                  </ul>
                  <span v-else>{{ data.item.email }}</span>
                </span>
              </v-tooltip>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item
              :key="`email-${item.email}-${uniqueKey()}`"
              :class="[itemSelected(item.id) ? 'selected-removed' : '']"
              @click.stop.prevent="selectEmail(item.id, item.email)"
              :eager="true"
              class="meeting-participant-list"
            >
              <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                <v-img
                  v-if="item.profilePhoto"
                  contain
                  :src="item.profilePhoto"
                ></v-img>
                <v-img
                  v-else
                  contain
                  src="@/assets/images/NoPhotoIcon.png"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <label>
                    <span v-if="item.firstName">
                      {{ item.firstName + " " + item.lastName }}
                    </span>
                    <span v-else>{{ item.email }}</span>
                  </label>
                </v-list-item-title>
                <v-list-item-subtitle v-if="item.firstName">
                  <label>
                    {{ item.email }}
                  </label>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar
                class="mt-0 mb-0 mr-2"
                size="40"
                v-if="itemSelected(item.id)"
              >
                <v-icon color="green" left>mdi-check </v-icon>
              </v-list-item-avatar>
              <v-list-item-action style="flex-direction: inherit">
                <v-btn
                  outlined
                  x-small
                  color="primaryDark"
                  class="mr-2"
                  v-if="item.is_listed_in_people === true"
                >
                  {{ $t("admin.lblListedInPeople") }}
                </v-btn>
                <v-btn
                  outlined
                  x-small
                  color="primaryDark"
                  v-if="item.is_registered_user === true"
                >
                  {{ $t("admin.lblRegistered") }}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-combobox>
      </v-col>
    </v-row>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { createUUID } from "../../utils/util";
import ABtn from "../../wrapper-component/ABtn.vue";
import _ from "lodash";
import peopleService from "../../api/peopleService";
import MessageSheet from "../MessageSheet.vue";

export default {
  name: "MeetingParticipants",
  components: {
    ABtn,
    MessageSheet,
  },
  data() {
    return {
      selectedAttendees: [],
      newAttendeeEmail: [],
      attendeeSearch: null,
      page: 1,
      itemsPerPage: 10000,
      offsetTop: 0,
      displayMessage: false,
      messageType: "",
      message: "",
      deletedUsers: [],
    };
  },
  props: {
    meetingAtteendeelist: Array,
    value: {
      type: Array,
      default: () => [],
    },
    mode: String,
    isAttendees: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "meeting",
    },
    suggestedList: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: null,
    },
    adHocEmail: {
      type: Boolean,
      default: true,
    },
    isAlternateEmailShow: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    setTimeout(async () => {
      this.selectedAttendees = await this.getUserDetails();
    }, 10);
  },
  watch: {
    async selectedAttendees(value, prev) {
      if (value) {
        let entry = this.selectedAttendees[this.selectedAttendees.length - 1];
        if (!entry) {
          this.$emit("onSelection", this.selectedAttendees);
          return;
        }
        if (entry.email) {
          const existingPerson = this.usersWithContactEmails.find(
            (elem) =>
              String(elem.email).toLowerCase().trim() ==
              String(entry.email).toLowerCase().trim()
          );
          if (!existingPerson) {
            const person = this.addItem(entry.email);
            this.selectedAttendees[this.selectedAttendees.length - 1] = person;
          }
        } else {
          const isLengthExceeded = this.maxLength(entry);
          if (isLengthExceeded && validateEmail(entry)) {
            const findUser = this.suggestionListItems.find(
              (user) => user.email === entry
            );
            if (!this.adHocEmail && !findUser) {
              this.selectedAttendees.pop();
            } else {
              const count = this.selectedAttendees.length - 1;
              this.isEmailvalidate = true;
              this.selectedAttendees[count] = this.addItem(entry);

              let existingCachedPerson = this.usersWithContactEmails.find(
                (elem) =>
                  elem.email.toLowerCase().trim() == entry.toLowerCase().trim()
              );

              if (!existingCachedPerson) {
                const existUser = await peopleService.check_email(
                  entry.toLowerCase().trim()
                );
                if (existUser.data && existUser.data.id) {
                  existingCachedPerson = existUser.data;
                  this.deletedUsers = this.deletedUsers.concat(existUser.data);
                }
              }
              if (existingCachedPerson) {
                const alternateIndex = this.selectedAttendees.findIndex(
                  (elem) => elem.id == existingCachedPerson.id
                );
                if (alternateIndex !== -1) {
                  const alternateUser = _.cloneDeep(
                    this.selectedAttendees[alternateIndex]
                  );
                  if (
                    alternateUser.emailList &&
                    alternateUser.emailList.length > 0
                  ) {
                    const exist = alternateUser.emailList.find(
                      (email) =>
                        email.toLowerCase().trim() ===
                        entry.toLowerCase().trim()
                    );
                    if (!exist) {
                      alternateUser.emailList.push(entry);
                    }
                  } else {
                    alternateUser.emailList = [entry];
                  }
                  this.selectedAttendees[alternateIndex] = alternateUser;
                  this.selectedAttendees.splice(count, 1);
                } else {
                  let peopleData = existingCachedPerson;
                  if (
                    existingCachedPerson.registered_email &&
                    existingCachedPerson.registered_email.toLowerCase() !==
                      entry.toLowerCase()
                  ) {
                    peopleData.email = peopleData.registered_email;
                    peopleData.emailList = [entry];
                  } else {
                    peopleData.email = entry;
                  }
                  this.selectedAttendees[count] = peopleData;
                }
              } else {
                const data = this.addItem(entry);
                this.selectedAttendees[count] = data;
              }
            }
          } else {
            this.isEmailvalidate = true;
            this.selectedAttendees.pop();
            if (!isLengthExceeded) {
              this.showMessageSheet(this.$t("ruleEmailMaxLength"), "error");
            }
          }
        }
        this.$emit("onSelection", this.selectedAttendees);
      }
    },
  },
  computed: {
    ...statesMap(),
    LoaderText() {
      return this.$t("LoaderText");
    },
    comboboxLable() {
      return this.isAttendees
        ? this.$t("agenda.lblAttendees")
        : this.$t("poll.lblSelectTarget");
    },
    attendeeParticipants() {
      const attendees = [];
      this.meetingAtteendeelist.forEach((user) => {
        attendees.push(user);
        if (user.emailList && user.emailList.length > 0) {
          user.emailList.forEach((email) => {
            if (email) {
              attendees.push({ ...user, email: email });
            }
          });
        }
      });
      return attendees;
    },
    peoples() {
      return this.userList
        .filter((item) => {
          if (item.is_registered_user === true) {
            return item;
          }
        })
        .map((obj) => {
          return {
            ...obj,
            email: obj.registered_email
              ? obj.registered_email
              : obj.display_email,
            attendedState: null,
          };
        });
    },
    localUserList() {
      return this.userList ? this.userList.concat(this.deletedUsers) : [];
    },
    suggestedItemMap() {
      const listItem = [];
      if (!this.suggestedList) return [];
      this.suggestedList.forEach((user) => {
        const existingPerson = this.peoples.find((elem) => elem.id == user.id);
        if (existingPerson) {
          listItem.push(existingPerson);
        } else {
          listItem.push(this.mapUser(user));
        }
      });
      return listItem;
    },
    suggestionListItems() {
      return this.type === "meeting" ? this.peoples : this.suggestedItemMap;
    },
    usersWithContactEmails() {
      const userEmails = [];
      this.localUserList.forEach((user) => {
        if (user.contactEmailIds && user.contactEmailIds.length > 0) {
          user.contactEmailIds.forEach((email) => {
            if (email) {
              const userData = {
                id: user.id,
                display_email: email,
                registered_email: user.registered_email,
                email: email,
                firstName: user.firstName,
                lastName: user.lastName,
                profilePhoto: user.profilePhoto ?? "",
                attendedState: user.attendedState ?? null,
                is_registered_user: user.is_registered_user,
                is_listed_in_people: user.is_listed_in_people,
              };
              userEmails.push(userData);
            }
          });
        }
      });
      return [
        ...this.suggestedItemMap,
        ...this.meetingAtteendeelist,
        ...userEmails,
      ];
      //return userEmails;
    },
  },
  methods: {
    ...mapActions({
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
    }),
    getUserDetails,
    mapUserDetails,
    uniqueKey() {
      return createUUID();
    },
    createUUID,
    addItem(emailId) {
      const newItem = {
        id: createUUID(),
        email: emailId,
        action: "add",
      };
      return newItem;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    maxLength(email) {
      if (email && typeof email === "string") {
        return email.length <= 70;
      } else {
        return true;
      }
    },
    filter(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      if (
        (item.firstName &&
          item.firstName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.lastName &&
          item.lastName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.email &&
          item.email.toLowerCase().indexOf(query.toString().toLowerCase()) !==
            -1)
      ) {
        return true;
      }
      return false;
    },
    itemSelected(itemId) {
      const selectedIndex =
        this.selectedAttendees && this.selectedAttendees.length > 0
          ? this.selectedAttendees.findIndex(
              (attendee) => attendee.id === itemId
            )
          : -1;
      if (selectedIndex !== -1) {
        return true;
      } else {
        return false;
      }
    },
    itemSelectedGroup(id) {
      const selectedIndex =
        this.selectedAttendees && this.selectedAttendees.length > 0
          ? this.selectedAttendees.findIndex((attendee) => attendee.id === id)
          : -1;
      if (selectedIndex !== -1) {
        return true;
      } else {
        return false;
      }
    },
    selectEmail(uid, emailId) {
      const existId = this.selectedAttendees.findIndex(
        (selected) => selected.id == uid
      );
      if (existId !== -1) {
        this.selectedAttendees.splice(existId, 1);
      } else {
        const userData = _.cloneDeep(this.userList);
        const result = userData.find((item) => item.id == uid);
        let people = {};
        if (result) {
          const contactEmailIds = result.contactEmailIds
            ? result.contactEmailIds.filter((email) => email !== emailId)
            : [];
          people = {
            id: result.id,
            email: emailId,
            firstName: result.firstName,
            lastName: result.lastName,
            profilePhoto: result.profilePhoto ?? "",
            title: result.title,
            attendedState: null,
            contactEmailIds: contactEmailIds,
          };
        } else {
          const peopleItem = this.suggestedItemMap.find(
            (item) => item.email == emailId
          );
          people = {
            id: peopleItem.id,
            email: emailId,
            display_email: emailId,
          };
        }

        this.selectedAttendees.push(people);
        this.attendeeSearch = null;
      }
    },
    mapUser(user) {
      return {
        id: user.id,
        email: user.email,
        display_email: user.registered_email,
        registered_email: user.registered_email,
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        profilePhoto: user.profilePhoto ?? "",
        title: "",
        is_registered_user: false,
        is_listed_in_people: false,
      };
    },
    deleteAttende(id) {
      const selectedIndex = this.selectedAttendees.findIndex(
        (item) => item.id === id
      );
      if (selectedIndex !== -1) {
        this.selectedAttendees.splice(selectedIndex, 1);
      }
      this.addAtteendees();
    },
    addAtteendees() {
      this.$emit("onSelection", this.selectedAttendees);
    },
    onUpdate(value) {
      if (value) {
        if (value.length === 0) {
          this.selectedAttendees = [];
        }
      }
    },
  },
};

async function getUserDetails() {
  let deletedUserList = [];
  const userWithIdExists = (id) =>
    this.localUserList.some((obj) => obj.id === id);
  const unmatchedObjects = this.meetingAtteendeelist.filter(
    (obj) => !userWithIdExists(obj.id)
  );
  const unmatchedIds = unmatchedObjects.map((obj) => obj.id);
  const deletedUsersIds = [];
  if (unmatchedIds.length) {
    const result = await this.getDeletedUsersList(unmatchedIds);
    if (result.length) {
      result.forEach((user) => {
        deletedUsersIds.push(user.id);
      });
      deletedUserList = deletedUserList.concat(result);
    }
  }

  const guestIds = unmatchedIds.filter(
    (guest) => !deletedUsersIds.includes(guest)
  );
  if (guestIds && guestIds.length > 0) {
    const guestObj = this.meetingAtteendeelist.filter((obj) =>
      guestIds.includes(obj.id)
    );
    if (guestObj) {
      deletedUserList = deletedUserList.concat(guestObj);
    }
  }
  if (deletedUserList.length > 0) {
    this.deletedUsers = deletedUserList;
  }
  const userList = this.localUserList;
  const matchedUser = filterUsersById(userList, this.meetingAtteendeelist);
  return this.mapUserDetails(matchedUser);
}

function filterUsersById(userList, attendeeList) {
  return attendeeList.filter((obj) => objectWithIdExists(obj.id, userList));
}

function objectWithIdExists(id, userList) {
  return userList.some((obj) => obj.id === id);
}

function mapUserDetails(users) {
  const _self = this;
  return users.map((user) => {
    let attendedState = null;
    let emailList = [];
    const selectedIndex = _self.meetingAtteendeelist.findIndex(
      (item) => item.id === user.id
    );
    if (selectedIndex !== -1) {
      attendedState =
        _self.meetingAtteendeelist[selectedIndex].attendedState ?? null;
      emailList = _self.meetingAtteendeelist[selectedIndex].emailList ?? [];
    }
    const existingPerson = this.localUserList.find(
      (elem) => elem.id == user.id
    );
    return {
      id: user.id,
      email: user.email,
      display_email: existingPerson ? existingPerson.display_email : user.email,
      registered_email: existingPerson
        ? existingPerson.registered_email
        : user.email,
      firstName: existingPerson?.firstName ?? "",
      lastName: existingPerson?.lastName ?? "",
      profilePhoto: existingPerson?.profilePhoto ?? "",
      title: existingPerson?.title ?? "",
      attendedState: attendedState,
      emailList: emailList,
      disabled: !!user.disabled,
    };
  });
}

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
};

function statesMap() {
  return mapState({
    userList: (state) => state.people.userList,
  });
}
</script>
<style >
input#searchComboBox {
  line-height: 21px !important;
}
.v-list-item:has(.combo-list) {
  margin: 0px !important;
  padding: 0px !important;
}
.combo-list {
  width: 100%;
}
.combo-list .v-list-item {
  width: 100%;
}
.combo-list .v-list-item {
  cursor: pointer;
}
.combo-list .v-list-item:hover {
  background-color: #e6e6e6 !important;
}
.combo-list .v-list-item.selected {
  background-color: #e6e6e6 !important;
}

.combo-list .v-list-item--link:before {
  background-color: #fff !important;
}

.combo-list .v-list-item label {
  cursor: pointer;
}

.user-combo-selection {
  background-color: #f4f4f4 !important;
  position: absolute;
  width: 100%;
  z-index: 9999999;
  top: 0px;
}
.v-list-group.selected .v-list-group__header {
  background-color: #e6e6e6 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.combo-group {
  width: 100%;
}
.v-list-item:has(.combo-group) {
  padding: 0px;
}
.v-list-item:has(.v-list-item--highlighted) {
  background-color: #e6e6e6 !important;
}
</style>